import { render, staticRenderFns } from "./creatPersonnel.vue?vue&type=template&id=79a78f42&scoped=true"
import script from "./creatPersonnel.vue?vue&type=script&lang=js"
export * from "./creatPersonnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a78f42",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a78f42')) {
      api.createRecord('79a78f42', component.options)
    } else {
      api.reload('79a78f42', component.options)
    }
    module.hot.accept("./creatPersonnel.vue?vue&type=template&id=79a78f42&scoped=true", function () {
      api.rerender('79a78f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/deliveryPersonnel/creatPersonnel.vue"
export default component.exports